import React, { FC, PropsWithChildren } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import {
  StyledActivityLogCard,
  StyledHorizontalDivider,
  StyledVerticalDivider,
} from './styled-activity-log-layout';

export const ActivityLogLayout: FC<PropsWithChildren> = ({ children }) => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));

  const divider = isLargeScreen ? (
    <StyledVerticalDivider orientation="vertical" flexItem />
  ) : (
    <StyledHorizontalDivider orientation="horizontal" />
  );

  return (
    <StyledActivityLogCard
      id="activity-log-layout"
      my={5}
      flex={1}
      direction={{
        xs: 'column',
        lg: 'row',
      }}
      divider={divider}
    >
      {children}
    </StyledActivityLogCard>
  );
};
